<app-supplier-select [supplier]="edit.supplier" [selectMode]="edit.model.typeId == 3 ? 'single' :'multiple' ">
</app-supplier-select>

